<template>
  <b-dropdown
    size="sm"
    variant="link"
    toggle-class="text-decoration-none p-0"
    no-caret
    right
    no-flip
  >
    <template v-slot:button-content>
      <div class="btn btn-icon">
        <span class="symbol symbol-circle symbol-40 border">
          <img v-if="image" :src="image" alt="" />

          <span v-else class="symbol-label">{{ name.charAt(0) }}</span>
        </span>
      </div>
    </template>

    <b-dropdown-text tag="div" class="min-w-md-350px">
      <div class="d-flex align-items-center">
        <div class="symbol symbol-circle symbol-90 border mr-4">
          <img v-if="image" :src="image" :alt="name" />

          <span v-else class="symbol-label" />
        </div>

        <div class="d-flex flex-column">
          <span class="font-weight-bolder" v-html="name || '&nbsp;'" />
          <span class="font-size-sm" v-html="role || '&nbsp;'" />
          <span class="font-size-sm" v-html="user.email || '&nbsp;'" />
        </div>
      </div>

      <div class="separator separator-dashed my-5"></div>

      <div class="navi scroll w-100">
        <b-dropdown-item
          link-class="p-0"
          :to="{ name: 'groups' }"
          v-if="$permissions.groups.read"
        >
          <div class="navi-item">
            <div class="navi-link bg-white px-0 d-flex">
              <div class="symbol symbol-white symbol-40 mr-2">
                <div class="symbol-label">
                  <i class="material-icons icon-xl">people</i>
                </div>
              </div>

              <div class="navi-text">
                <div class="font-weight-bolder">Groups</div>
                <div class="text-dark-50">Manage groups</div>
              </div>
            </div>
          </div>
        </b-dropdown-item>

        <b-dropdown-item
          link-class="p-0"
          :to="{ name: 'members' }"
          v-if="$permissions.users.read"
        >
          <div class="navi-item">
            <div class="navi-link bg-white px-0 d-flex">
              <div class="symbol symbol-white symbol-40 mr-2">
                <div class="symbol-label">
                  <i class="material-icons icon-xl">people</i>
                </div>
              </div>

              <div class="navi-text">
                <div class="font-weight-bolder">Members</div>
                <div class="text-dark-50">Manage members</div>
              </div>
            </div>
          </div>
        </b-dropdown-item>

        <b-dropdown-item link-class="p-0" :to="{ name: 'logout' }">
          <div class="navi-item">
            <div class="navi-link bg-white px-0 d-flex">
              <div class="symbol symbol-white symbol-40 mr-2">
                <div class="symbol-label">
                  <i class="material-icons icon-xl">logout</i>
                </div>
              </div>

              <div class="navi-text">
                <div class="font-weight-bolder">Logout</div>
                <div class="text-dark-50">End session and logout</div>
              </div>
            </div>
          </div>
        </b-dropdown-item>
      </div>
    </b-dropdown-text>
  </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "User",
  computed: {
    ...mapGetters(["user"]),
    name() {
      return `${this.user.first_name} ${this.user.last_name}`;
    },
    image() {
      return this.user.image ? this.user.image["256"] : null;
    },
    role() {
      let role = this.user.role ? this.user.role.name : null;

      switch (role) {
        case "admin":
          return "Administrator";
        case "teamleader":
          return "Team Leader";
        case "member":
          return "Member";
        default:
          return "&nbsp;";
      }
    },
  },
};
</script>
